module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-2.4aaaecab.png";